import type { BatchCreateOrdersInput } from "@/api/purchase";

const KEY = "stahlia.reach.offeneBestellung.v1";
const record = (v: unknown): v is Record<string, unknown> => typeof v === "object" && v !== null && !Array.isArray(v);
const keys = (v: Record<string, unknown>, allowed: string[]) => Object.keys(v).every(k => allowed.includes(k));
const positiveInt = (v: unknown) => typeof v === "number" && Number.isSafeInteger(v) && v > 0;

function valid(v: unknown): v is BatchCreateOrdersInput {
  if (!record(v) || !keys(v, ["client_batch_id", "source", "include_dead", "groups"]) ||
    typeof v.client_batch_id !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v.client_batch_id) ||
    v.source !== "reichweite" || typeof v.include_dead !== "boolean" || !Array.isArray(v.groups) || !v.groups.length) return false;
  return v.groups.every(g => record(g) && keys(g, ["supplier_id", "order_date", "status", "order_number", "items"]) &&
    positiveInt(g.supplier_id) && typeof g.order_date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(g.order_date) &&
    (g.status === "entwurf" || g.status === "bestellt") && (g.order_number === undefined || typeof g.order_number === "string") &&
    Array.isArray(g.items) && g.items.length > 0 && g.items.every((i: unknown) => record(i) && keys(i, ["stock_item_id", "qty"]) && positiveInt(i.stock_item_id) && positiveInt(i.qty) && (i.qty as number) <= 1000000));
}

export interface OffeneBestellung {
  request: BatchCreateOrdersInput;
  lastAttemptId: string;
  lastAttemptAt: number;
}

export function leseOffeneBestellung(): OffeneBestellung | null {
  let raw: string | null;
  try { raw = sessionStorage.getItem(KEY); } catch { return null; }
  if (!raw) return null;
  try {
    const value: unknown = JSON.parse(raw);
    if (record(value) && valid(value.request) && typeof value.lastAttemptId === "string" && value.lastAttemptId.length > 0 &&
      typeof value.lastAttemptAt === "number" && Number.isSafeInteger(value.lastAttemptAt) && value.lastAttemptAt >= 0) return value as unknown as OffeneBestellung;
    if (valid(value)) {
      const legacy = { request: value, lastAttemptId: value.client_batch_id, lastAttemptAt: Date.now() };
      speichereOffeneBestellung(legacy);
      return legacy;
    }
  } catch { /* JSON ungültig */ }
  try { sessionStorage.removeItem(KEY); } catch { /* Speicher nicht verfügbar */ }
  return null;
}

export function speichereOffeneBestellung(vorgang: OffeneBestellung): boolean {
  try {
    const raw = JSON.stringify(vorgang);
    sessionStorage.setItem(KEY, raw);
    return sessionStorage.getItem(KEY) === raw;
  } catch { return false; }
}

export function entferneOffeneBestellung(id: string, attemptId: string): boolean {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw === null) return true;
    const stored: unknown = JSON.parse(raw);
    if (!record(stored) || !record(stored.request) || stored.request.client_batch_id !== id || stored.lastAttemptId !== attemptId) return false;
    sessionStorage.removeItem(KEY);
    return sessionStorage.getItem(KEY) === null;
  } catch { return false; }
}
